module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-DealerDraftMazda-Established2.2221f69f.jpeg";